import CrsIcon from "src/assets/CrsIcon.svg?react";
import {
  getDefaultCRSBusinessProfileReport,
  getDefaultCRSEquifaxCreditReport,
  getDefaultCRSExperianBusinessSearch,
  getDefaultCRSExperianCreditReport,
  getDefaultCRSIntellisenseBusinessReport,
  getDefaultCRSLexisNexisBridgerSearch,
  getDefaultCrsTransunionCreditReport,
  getDefaultCrsTransunionIMVBasic,
} from "src/connections/connectionConfigs/crs/crsResources";
import { CrsTemplate } from "src/connections/connectionConfigs/crs/crsTemplate";
import { ConnectionConfig } from "src/connections/connectionConfigs/types";

export const CRS_CONFIG: ConnectionConfig<"crs"> = {
  icon: CrsIcon,
  name: "US | CRS",
  description: "The proven leader in credit API technology",
  template: CrsTemplate,
  resources: {
    experian_business_profile_report: {
      externalLink:
        "https://docs.taktile.com/third-party-connections/built-in-connection-nodes/credit-bureaus/crs#experian-business-profile-report",
      integrationResource: getDefaultCRSBusinessProfileReport,
    },
    experian_business_search: {
      externalLink:
        "https://docs.taktile.com/third-party-connections/built-in-connection-nodes/credit-bureaus/crs#experian-business-search-report",
      integrationResource: getDefaultCRSExperianBusinessSearch,
    },
    experian_credit_report: {
      externalLink:
        "https://docs.taktile.com/third-party-connections/built-in-connection-nodes/credit-bureaus/crs#experian-credit-report",
      integrationResource: getDefaultCRSExperianCreditReport,
    },
    experian_intelliscore_business_report: {
      externalLink:
        "https://docs.taktile.com/third-party-connections/built-in-connection-nodes/credit-bureaus/crs#experian-intelliscore-business-report",
      integrationResource: getDefaultCRSIntellisenseBusinessReport,
    },
    transunion_credit_report: {
      externalLink:
        "https://docs.taktile.com/third-party-connections/built-in-connection-nodes/credit-bureaus/crs#transunion-credit-report",
      integrationResource: getDefaultCrsTransunionCreditReport,
    },
    lexisnexis_bridger_search: {
      externalLink:
        "https://docs.taktile.com/third-party-connections/built-in-connection-nodes/credit-bureaus/crs#lexisnexis-bridger-search",
      integrationResource: getDefaultCRSLexisNexisBridgerSearch,
    },
    transunion_imv_basic: {
      externalLink:
        "https://docs.taktile.com/third-party-connections/built-in-connection-nodes/credit-bureaus/crs#truvalidate-identity-manager-verification-report",
      integrationResource: getDefaultCrsTransunionIMVBasic,
    },
    crs_equifax_credit_report: {
      externalLink:
        "https://docs.taktile.com/third-party-connections/built-in-connection-nodes/credit-bureaus/crs#equifax-credit-report",
      integrationResource: getDefaultCRSEquifaxCreditReport,
    },
  },
};
